import { OG_DEFAULT } from "@/seo/ogImages";
import type { BlogFrontmatter } from "./types";

// Kein eigenes Motiv -> Default-OG-Bild (1200x630) aus src/seo/ogImages.ts.
const OG_IMAGE = OG_DEFAULT.image;

export const frontmatter: BlogFrontmatter = {
  title: "LinkedIn Outbound: Erstgespräche öffnen ohne Spam-Effekt",
  slug: "linkedin-outbound-ohne-spam",
  description:
    "LinkedIn Outbound, das Antworten bekommt: Relevanz statt Massennachrichten. So öffnen Sie Erstgespräche mit Zielaccounts, ohne als Spam wahrgenommen zu werden.",
  primaryKeyword: "linkedin outbound",
  secondaryKeywords: ["linkedin nachrichten vorlage", "social selling b2b"],
  author: "moritz",
  datePublished: "2026-07-01",
  dateModified: "2026-07-01",
  image: OG_IMAGE,
  imageAlt: "Illustration: spamfreies LinkedIn Outbound für B2B-Erstgespräche",
  internalLinks: ["/dm-outbound", "/blog/b2b-leadgenerierung-linkedin"],
  draft: true,
  kurzGesagt:
    "Erfolgreiches LinkedIn Outbound setzt auf Relevanz und Timing statt auf Masse und Templates. Wer vorher Sichtbarkeit aufbaut und mit echtem Bezug anschreibt, öffnet Gespräche; wer generische Massennachrichten verschickt, produziert Spam und verbrennt seine Domain-Reputation.",
  faq: [
    { q: "Wie viele Nachrichten pro Tag sind sinnvoll?", a: "Stub: wird ausgearbeitet." },
    { q: "Automatisierung: ja oder nein?", a: "Stub: wird ausgearbeitet." },
    { q: "Wie personalisiert man ohne Mehraufwand?", a: "Stub: wird ausgearbeitet." },
  ],
};

export default function Article() {
  return (
    <>
      <p>
        <em>Entwurf / Gliederung. Volltext folgt.</em>
      </p>
      <h2>Gliederung</h2>
      <ul>
        <li>Warum Massen-Outbound scheitert (Spam-Effekt, niedrige Antwortraten)</li>
        <li>Voraussetzung: Sichtbarkeit vor Ansprache (Ads + Content)</li>
        <li>Anatomie einer relevanten Erstnachricht</li>
        <li>These: Outbound ist Teil eines Systems, kein Alleingang</li>
        <li>Beispiel: Antwortrate warm vs. kalt</li>
        <li>Übergang vom positiven Signal zum Termin (telefonische Qualifizierung)</li>
      </ul>
    </>
  );
}
